module.exports = __webpack_public_path__ + "img/ic-rue.175ceff0.svg";